<template>
  <div class="col-lg-12">

    <b-collapse id="filters" class="p-2">
      <b-row>
        <b-col lg="3">
          <search/>
        </b-col>
        <b-col lg="3">
          <product-type/>
        </b-col>
        <b-col lg="3">
          <quantity/>
        </b-col>
        <b-col lg="3">
          <per-page/>
        </b-col>
        <b-col lg="3">
          <brand/>
        </b-col>
        <b-col >
          <category/>
        </b-col>

      </b-row>
    </b-collapse>

  </div>
</template>

<script>
import Search from "./Filters/Search";
import ProductType from "./Filters/ProductType";
import Quantity from "./Filters/Quantity";
import PerPage from "./Filters/PerPage";
import Brand from "./Filters/Brand";
import Category from "./Filters/Category/Category";

export default {
  name: "Filters",
  components: {Search, ProductType, Quantity, PerPage, Brand, Category,}
}
</script>

<style scoped>

</style>